import React from 'react';
import Select from 'react-select';
import Flag from 'react-world-flags';

// Lista completa de idiomas suportados com códigos de bandeiras ISO 3166-1 alpha-2
export const languages = [
    { code: 'auto', name: 'Auto Detect', flag: '🌐' },
    { code: 'en', name: 'English', flag: 'US' }, // Bandeira dos EUA
    { code: 'pt', name: 'Portuguese', flag: 'BR' }, // Bandeira do Brasil
    { code: 'es', name: 'Spanish', flag: 'ES' }, // Bandeira da Espanha
    { code: 'fr', name: 'French', flag: 'FR' }, // Bandeira da França
    { code: 'de', name: 'German', flag: 'DE' }, // Bandeira da Alemanha
    { code: 'it', name: 'Italian', flag: 'IT' }, // Bandeira da Itália
    { code: 'ru', name: 'Russian', flag: 'RU' }, // Bandeira da Rússia
    { code: 'zh', name: 'Chinese', flag: 'CN' }, // Bandeira da China
    { code: 'ja', name: 'Japanese', flag: 'JP' }, // Bandeira do Japão
    { code: 'ko', name: 'Korean', flag: 'KR' }, // Bandeira da Coreia do Sul
    { code: 'hi', name: 'Hindi', flag: 'IN' }, // Bandeira da Índia
    { code: 'ar', name: 'Arabic', flag: 'SA' }, // Bandeira da Arábia Saudita
    { code: 'tr', name: 'Turkish', flag: 'TR' }, // Bandeira da Turquia
    { code: 'nl', name: 'Dutch', flag: 'NL' }, // Bandeira dos Países Baixos
    { code: 'sv', name: 'Swedish', flag: 'SE' }, // Bandeira da Suécia
    { code: 'no', name: 'Norwegian', flag: 'NO' }, // Bandeira da Noruega
    { code: 'pl', name: 'Polish', flag: 'PL' }, // Bandeira da Polônia
    { code: 'he', name: 'Hebrew', flag: 'IL' }, // Bandeira de Israel
    { code: 'fi', name: 'Finnish', flag: 'FI' }, // Bandeira da Finlândia
    { code: 'el', name: 'Greek', flag: 'GR' }, // Bandeira da Grécia
    { code: 'da', name: 'Danish', flag: 'DK' } // Bandeira da Dinamarca
];

// Formatação das opções com as bandeiras e os nomes dos idiomas
const formatOptionLabel = (option) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {option.flag !== '🌐' ? (
                <Flag code={option.flag} style={{ width: '20px', height: '20px', marginRight: '10px' }} />
            ) : (
                <span>{option.flag}</span>
            )}
            <span>{option.name}</span>
        </div>
    );
};

// Estilos personalizados para o componente react-select
const customStyles = {
    control: (provided, state) => {
        return {
            ...provided,
            width: '100%',
            background: 'linear-gradient(to bottom, #444, #333)',
            borderColor: state.isFocused ? '#ffaa00' : '#ff7600',
            borderWidth: '3px',
            borderRadius: '30px',
            boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.6)',
            color: 'white',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxSizing: 'border-box'
        };
    },
    option: (provided, { isFocused, isSelected }) => {
        return {
            ...provided,
            backgroundColor: isSelected ? '#ff7600' : isFocused ? 'rgba(255, 165, 0, 0.8)' : 'transparent',
            color: 'white',
            padding: '10px',
            borderRadius: '30px',
        };
    },
    singleValue: (provided) => {
        return {
            ...provided,
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };
    },
    menu: (provided) => {
        return {
            ...provided,
            backgroundColor: '#333',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
            borderRadius: '30px',
            overflow: 'hidden',
        };
    },
    valueContainer: (provided) => {
        return {
            ...provided,
            justifyContent: 'center',
            padding: '0',
            width: '100%'
        };
    },
    indicatorsContainer: (provided) => {
        return {
            ...provided,
            height: '100%',
        };
    },
    indicatorSeparator: () => {
        return {
            display: 'none',
        };
    },
    menuPortal: (base) => {
        return { ...base, zIndex: 9999 };
    },
};

// Componente LanguageSelector que aceita as props: label, selectedLanguage, onLanguageChange e options
const LanguageSelector = ({ label, selectedLanguage, onLanguageChange, options }) => {
    return (
        <div className="language-selector" style={{ width: '100%', maxWidth: '600px' }}>
            <label>{label}</label>
            <Select
                options={options}
                getOptionValue={(option) => option.code}
                formatOptionLabel={formatOptionLabel}
                styles={customStyles}
                onChange={(option) => onLanguageChange(option.code)}
                value={options.find(lang => lang.code === selectedLanguage)}
                placeholder="Select Language"
                isClearable={false}
                isSearchable={false}
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
            />
        </div>
    );
};

export default LanguageSelector;
